module.exports = __webpack_public_path__ + "img/rod_1.4a4620c4.png";